'use strict';

const availableCampaigns = state => [...state.availableCampaigns];

export default {
  availableCampaigns
};
